// extracted by mini-css-extract-plugin
export default {"statusContainer":"DevStatus_statusContainer__5RNER","statusIcon":"DevStatus_statusIcon__3O1+L"};